export default __webpack_public_path__ + "static/media/delete.de57376e.svg";